import { render } from "./Onboarding.vue?vue&type=template&id=5bc5889b&scoped=true"
import script from "./Onboarding.vue?vue&type=script&lang=js"
export * from "./Onboarding.vue?vue&type=script&lang=js"

import "./Onboarding.vue?vue&type=style&index=0&id=5bc5889b&lang=scss&scoped=true"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc5889b"]])

export default __exports__